import { ArrowDown, ArrowUp, Minus } from "lucide-react";
import { cn } from "@/lib/utils";
import { formatChangePct, type TrendResult } from "./utils";

/**
 * Direction indicator for month-on-month traffic.
 *
 * Renders nothing when no trend can be derived - a single month of data, or no
 * data at all. Showing a neutral arrow there would imply a comparison we never
 * made. Colours stay low-saturation: falling traffic is not unambiguously bad
 * for a company being diligenced.
 */
export default function TrendChip({ trend }: { trend: TrendResult }) {
  if (!trend.direction) return null;

  const pct = formatChangePct(trend.changePct);

  const Icon =
    trend.direction === "up" ? ArrowUp : trend.direction === "down" ? ArrowDown : Minus;

  return (
    <span
      className={cn(
        "inline-flex items-center gap-0.5 rounded px-1 py-0.5 text-xs font-medium tabular-nums",
        trend.direction === "up" &&
          "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
        trend.direction === "down" && "bg-rose-500/10 text-rose-600 dark:text-rose-400",
        trend.direction === "flat" && "bg-muted/50 text-muted-foreground"
      )}
    >
      <Icon className="h-3 w-3" aria-hidden="true" />
      {pct ?? (trend.direction === "flat" ? "Flat" : null)}
    </span>
  );
}
